var scope_0 = require('/zeit/7c199a67/node_modules/mdx-deck/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/28681dbb921f3c01a991d69e611e5f40.js').default;export default
        Object.assign({}, scope_0 )
    